import { z } from "zod";

export const ControleMateriaisSchema = z.object({
  idMateriaisControlados: z.number().optional(),
  nroMaterial: z.string().optional(),
  descricao: z.string().optional(),
  ativo: z.boolean().optional().default(true),
  nomeArquivo: z.string().optional().nullable(),
  delete: z.boolean().optional().nullable(),
  arquivo: z.instanceof(File).optional().nullable(),
});

export type ControleMateriaisForm = z.infer<typeof ControleMateriaisSchema>;
